<script>
	import Container from '../Container/Container.svelte';
	import Hand from '../../../assets/hand_wave.svelte';
	import PrimaryButton from '../Buttons/PrimaryButton.svelte';
	import GrayPrimaryButton from '../Buttons/GrayPrimaryButton.svelte';
	export let onMouseDown = () => {};
	export let startNew = () => {};
	export let goBack = () => {};
	export let gameOrRound = '';
</script>

<div class="modalContainer">
	<Container borderRadius="21">
		<div class="innerModalContainer">
			<div class="modalSVG">
				<Hand />
			</div>
			<div class="modalTextContainer">
				<span class="modalText">{`This will end the ${gameOrRound} for all`}</span>
			</div>
			<div class="modalButtons">
				<GrayPrimaryButton
					width="135"
					height="45"
					fontSize="18"
					text="Cancel"
					disabled={false}
					{onMouseDown}
					onClick={goBack}
				/>
				<PrimaryButton
					width="135"
					height="45"
					fontSize="18"
					text="Proceed"
					disabled={false}
					{onMouseDown}
					onClick={startNew}
				/>
			</div>
		</div>
	</Container>
</div>

<style>
	.modalContainer {
		width: 331px;
		height: 223px;
	}
	.innerModalContainer {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
	.modalSVG {
		width: 65px;
		height: 65px;
	}
	.modalTextContainer {
		width: 100;
		display: flex;
		justify-content: center;
	}
	.modalText {
		font-family: Pally;
		font-style: normal;
		font-weight: bold;
		font-size: 22px;
		line-height: 30px;
		text-align: center;
		letter-spacing: -0.015em;
		color: #f5685c;
		text-shadow: 0px 1.73288px 0px rgba(0, 0, 0, 0.15);
	}
	.modalButtons {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
</style>
